import type { Experience as EncodedExperience } from '@/shared/api/experience';

import type { Experience } from './models';

type PhotoWithThumbnails = {
  type: string;
  thumbnail: string;
  medium: string;
  thumbnail_s: string;
  thumbnail_m: string;
  thumbnail_l: string;
  thumbnail_xl: string;
};

export const normalizeExperience = (encoded: EncodedExperience): Experience => {
  const photos: PhotoWithThumbnails[] = encoded.photos.map((photo) => {
    return {
      type: photo.type,
      thumbnail: photo.thumbnail,
      medium: photo.medium,
      thumbnail_s: photo.thumbnail,
      thumbnail_m: photo.thumbnail,
      thumbnail_l: photo.thumbnail,
      thumbnail_xl: photo.thumbnail,
    };
  });

  return {
    id: encoded.id,
    annotation: encoded.annotation,
    duration: encoded.duration,
    format: encoded.format,
    geo: {
      city: encoded.geo.city ?? [],
      country: encoded.geo.country ?? [],
      region: encoded.geo.region,
    },
    grade: encoded.grade,
    guide: encoded.guide,
    is_instant_booking: encoded.is_instant_booking,
    is_new: encoded.is_new,
    is_paid: encoded.is_paid,
    max_persons: encoded.max_persons,
    movement_type: encoded.movement_type,
    photos,
    price: encoded.price,
    rating: encoded.rating,
    review_count: encoded.review_count,
    schedule: encoded.schedule,
    schedule_type: encoded.schedule_type,
    status: encoded.status,
    tagline: encoded.tagline,
    title: encoded.title,
    type: encoded.type,
    url: encoded.url,
    text: encoded.text,
    discount: encoded.discount,
    meeting_point: {
      text: encoded.meeting_point?.text ?? null,
    },
    show_promotion_badge:
      (encoded as EncodedExperience & { show_promotion_badge?: boolean }).show_promotion_badge ?? false,
    legal_exp_type:
      ((encoded as EncodedExperience & { legal_exp_type?: string }).legal_exp_type as
        | 'tour'
        | 'multiday_excursion'
        | null) ?? null,
    accommodation: ((encoded as EncodedExperience & { accommodation?: { paid_separately: boolean } | null })
      .accommodation ?? null) as { paid_separately: boolean } | null,
  };
};
